import {Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import { UnsubscribeComponent } from 'app/main/pages/unsubscribe.component';
import { User } from 'app/entities';

@Component({
    selector     : 'navbar',
    templateUrl  : './navbar.component.html',
    styleUrls    : ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarComponent extends  UnsubscribeComponent implements OnInit
{
    // Private
    _variant: string = 'vertical-style-1';

    user: User = null;

    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2
    )
    {
        super()
    }

    ngOnInit() {
    }

    get variant(): string
    {
        return this._variant;
    }

    @Input()
    set variant(value: string)
    {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
}
